import {
  FILE_MANAGER_PAGE_COMPONENT_ID,
  SingleFileManagerComponentState,
} from '../../../redux/file-manager-component/file-manager-component.types';
import { createComponentOpenWrapperReducer } from '../../../redux/reducers/utils/reducer-wrapper.utils';
import { Action } from '../../../redux/redux.types';
import {
  compressFlow,
  CompressFlowState,
} from '../compress-flow/compress-flow.reducer';
import {
  deleteFilesModal,
  DeleteFilesModalState,
} from './delete-files-modal.reducer';
import { expandMode, ExpandModeState } from './expand-mode.reducer';
import { selection, SelectionState } from './selection.reducer';

export interface FileManagerPageState {
  selection: SelectionState;
  expandMode: ExpandModeState;
  deleteFilesModal: DeleteFilesModalState;
  compressFlow: CompressFlowState;
}

const selectionReducerWithinScope = createComponentOpenWrapperReducer(
  selection,
  FILE_MANAGER_PAGE_COMPONENT_ID,
);

export const fileManager = (
  state: FileManagerPageState,
  action: Action,
  fileManagerComponent: SingleFileManagerComponentState,
): FileManagerPageState => {
  return {
    selection: selectionReducerWithinScope(
      state && state.selection,
      action,
      fileManagerComponent.currentFolder.idsList,
    ),
    expandMode: expandMode(state && state.expandMode, action),
    deleteFilesModal: deleteFilesModal(state && state.deleteFilesModal, action),
    compressFlow: compressFlow(state && state.compressFlow, action),
  };
};
